<template>
  <div class="item-wrapper">
    <div class="item-bottom">
      <div class="preview">
        <img
          @click="goToSliderItem(item)"
          :src="imgDomain + item.img_url"
          class="img"
        />
        <!-- <div v-if="tag" class="tag">
					<span>{{tag}}</span>
				</div> -->
        <transition name="fade">
          <span class="title" v-if="addToCartChosenItem == item.id">
            <b>ADDED</b>
          </span>
        </transition>
      </div>
      <div class="desc tagg">{{ item.type }}</div>
      <div class="price title">
        <PriceFormatter :price="displayPrice(item)" />
        <PriceFormatter
          v-if="displayOldPrice(item)"
          :price="displayOldPrice(item)"
          rootClass="discount"
        />
      </div>
      <a @click="goToSliderItem(item)" class="desc card-title">{{
        item.title
      }}</a>
      <button class="button" @click="$emit('addToCart', item, item.id)">
        <span>Add to cart</span>
      </button>
    </div>
  </div>
</template>

<script>
import PriceFormatter from "./PriceFormatter.vue";

export default {
  name: "ProductCard",
  props: ["item", "addToCartChosenItem", "sliderIsClickble", "tag", "currency"],
  components: {
    PriceFormatter,
  },
  data: function () {
    return {
      imgDomain: "",
    };
  },
  mounted() {
    this.imgDomain = process.env.VUE_APP_STATIC_DOMAIN;
  },
  methods: {
    displayPrice(item) {
      return item.internal_price || item.price;
    },
    displayOldPrice(item) {
      const price = parseFloat(this.displayPrice(item));
      const oldPrice = item.internal_old_price || item.old_price;
      const numericOldPrice = parseFloat(oldPrice);

      if (
        !oldPrice ||
        Number.isNaN(numericOldPrice) ||
        numericOldPrice <= 0 ||
        (!Number.isNaN(price) && numericOldPrice <= price)
      ) {
        return null;
      }

      return oldPrice;
    },
    goToSliderItem(item) {
      let self = this;
      setTimeout(() => {
        if (self.sliderIsClickble == true) {
          self.$emit("goToProduct", item);
        }
      }, 200);
    },
  },
};
</script>
